<template>
  <page-loader v-if="loadingStatus == 'loading'" />
  <div class="contain-section">
    <div class="row">
      <div class="col-sm-12">
        <div class="inner-box">
          <div class="banner-box">
            <img
              class="rounded-4 h-400 img-row-feedback"
              :src="history && history.main_image ? history.main_image[0].url : ''"
              alt="Logo"
            />
          </div>
          <h3 class="d-flex justify-content-center w-100 mb-0 heading-motherline">
            {{ history ? history.heading : "" }}
          </h3>
          <!-- Heading Row starts here -->
          <div class="cards-row-grid-row-grid-motherline">
            <div class="col-sm-12 col-md-3 mt-3 mt-lg-0">
              <div class="hightlight-box">
                <span>Your Haplogroup is</span>
                <h4>{{ motherlineStore.result.haplogroup }}</h4>
              </div>
            </div>
            <div
              v-if="motherlineStore.result.subclade"
              class="col-sm-12 col-md-3 mt-3 mt-lg-0"
            >
              <div class="hightlight-box">
                <span>Your Haplotype is</span>
                <h4>{{ motherlineStore.result.subclade }}</h4>
              </div>
            </div>
          </div>
          <!-- Heading Row ends here -->

          <!-- grid row starts here -->
          <div class="motherline-grid-row">
            <!-- <div
              class="col-sm-12 justify-content-center d-flex align-items-center"
              :class="motherlineStore.result.subclade ? 'col-md-6' : 'col-md-9'"> -->
            <div>
              <!-- <b
                class="d-flex justify-content-start text-start w-100 fs-6 fs-sm-5 lh-2 motherline-clr-code"
              >
                <i>
                  <div
                    v-html="motherlineStore.result.content.contentOne.body"
                  />
                </i>
              </b> -->
              <div
                v-html="motherlineStore.result.content.contentOne.body"
                class="text-start text-14"
              />
            </div>

            <img
              class="content-img-motherline rounded-2"
              :src="motherlineStore.result.content.contentOne.image"
              alt=""
            />
            <!-- </div> -->
          </div>
          <!-- grid row ends here -->

          <div class="motherline-grid-row-sec">
            <!-- <img :src="motherlineStore.result.content.contentOne.image" alt="" /> -->
            <!-- <div v-html="motherlineStore.result.content.contentOne.body" /> -->
            <!-- <img :src="motherlineStore.result.content.contentTwo.image" alt="" /> -->
            <!-- <div v-html="motherlineStore.result.content.contentTwo.body" /> -->

            <img
              class="content-img-motherline rounded-2 margin-x"
              :src="motherlineStore.result.content.contentTwo.image"
              alt=""
            />

            <div
              v-html="motherlineStore.result.content.contentTwo.body"
              class="text-start text-14"
            />

            <ul
              class="d-flex flex-column justify-content-start text-start w-100 fs-6 lh-2 text-dark gap-2 mt-5"
            >
              <li
                v-for="citation in motherlineStore.result.content.citations"
                :key="citation.id"
              >
                <a
                  v-if="citation.type === 'external_url'"
                  :href="citation.source"
                  class="text-dark fs-14"
                >
                  {{ citation.title }}
                </a>
                <div v-else>{{ citation.title }}</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import "../../../styles/pages/ancentry/recent-ancetry.scss";
import { useMotherlineStore } from "@/store/parentalStore";
import { getMotherlineHistory } from "@/services/motherline";
import { ref, onMounted } from "vue";
const motherlineStore = useMotherlineStore();
const loadingStatus = ref("loading");
const history = ref({});
onMounted(async () => {
  history.value = await getMotherlineHistory();
  loadingStatus.value = "loaded";
});
</script>
